module.exports = __webpack_public_path__ + "static/media/traget.95ebdd59.png";